module.exports = __webpack_public_path__ + "img/24.1ea1f1bb.png";